import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { UNIT_OBJECT } from 'constants/unit';

import TableItemCellRenderer from './table-item-cell-renderer';
import styles from './cell-renderer.less';

const TableTotalCellRenderer = forwardRef((props, ref) => {
  const { value, colDef } = props;

  // Special handling of the 'Total' cell for column totals
  const totalColDef =
    value === 'Total' && colDef.field === 'group' ? UNIT_OBJECT : colDef;

  return (
    <TableItemCellRenderer
      ref={ref}
      className={classnames(styles.rowTotal)}
      value={value}
      colDef={totalColDef}
    />
  );
});

TableTotalCellRenderer.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.shape({
      display: PropTypes.string,
    }),
  ]),
  colDef: PropTypes.object.isRequired,
};

export default TableTotalCellRenderer;
export { TableTotalCellRenderer };
